import { ValidationSummary } from 'devextreme-react/validation-summary';
import { Box, Item } from 'devextreme-react/box';
import Toolbar, { Item as ToolbarItem } from 'devextreme-react/toolbar';
import {
	ChangeOrderButton,
	CreateEstimateButton,
	ExitButton,
	InstallDatesPanel,
	PhotoReferenceGuideLink,
	PlumbingBanner,
	RequestCancellationButton,
	RetailOrderAddNoteButton,
	RetailOrderCommunicationButton,
	RetailOrderFilesButton,
	RetailOrderInformationCards,
	RetailOrderNotesPanel,
	RetailOrderPage,
	RetailOrderProducts,
	RetailOrderProgress,
	RetailOrderProgressStep,
	SaveButton,
	SetToPendingButton,
	ViewChangeRequestButton
} from '../../../features/cfi/retail-order';
import '../../../css/order.scss';

export default function RetailOrderInstallPage() {

	return (
		<RetailOrderPage>

			<PlumbingBanner />

			<RetailOrderInformationCards />

			<RetailOrderProgress />

			<ValidationSummary />

			<Box>
				<Item ratio={1}>
					<Toolbar className='button-toolbar' multiline={true}>
						<ToolbarItem>
							<SaveButton step={RetailOrderProgressStep.Install} />
						</ToolbarItem>
						<ToolbarItem>
							<RetailOrderCommunicationButton />
						</ToolbarItem>
						<ToolbarItem>
							<RetailOrderFilesButton />
						</ToolbarItem>
						<ToolbarItem>
							<SetToPendingButton />
						</ToolbarItem>
						<ToolbarItem>
							<CreateEstimateButton />
						</ToolbarItem>
						<ToolbarItem>
							<ChangeOrderButton step={RetailOrderProgressStep.Install} />
						</ToolbarItem>
						<ToolbarItem>
							<ViewChangeRequestButton step={RetailOrderProgressStep.Install} />
						</ToolbarItem>
						<ToolbarItem>
							<RequestCancellationButton />
						</ToolbarItem>
						<ToolbarItem>
							<ExitButton />
						</ToolbarItem>
					</Toolbar>
				</Item>
				<Item ratio={0} baseSize={190}>
					<Toolbar className='button-toolbar' multiline={true}>
						<ToolbarItem>
							<RetailOrderAddNoteButton showNoteType={false} changeOrder={false} />
						</ToolbarItem>
					</Toolbar>
				</Item>
			</Box>

			<Box>
				<Item ratio={1}>
					<InstallDatesPanel />
				</Item>
				<Item ratio={1}>
					<RetailOrderNotesPanel height={200} />
				</Item>
			</Box>

			<PhotoReferenceGuideLink />

			<RetailOrderProducts />

		</RetailOrderPage>
	)
}
